module.exports = __webpack_public_path__ + "static/DAWN0-56f034cdd825a284b54ebbb4815d9f9d.jpg";